import { Dialog } from "primereact/dialog";
import { useForm, Controller } from "react-hook-form";
import React, { useState, useEffect, useRef } from "react";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import InputTextElement from "../../../Components/UiComponents/InputTextElement";
import SingleSelectElement from "../../../Components/UiComponents/SingleSelectElement";
import CalendarElement from "../../../Components/UiComponents/CalendarElement";
import { getSeq } from "../../../Services/opportunityService";
import { create } from "../../../Services/opportunityService";
import moment from "moment";
import CreateNewStakeHolder from "../Stakeholders/CreateNewStakeHolder";
import { getCustomer } from "../../../Services/customerServices";
import DropdownElement from "../../../Components/UiComponents/DropdownElement";
import _, { filter } from "lodash";
import { getUsersList } from "../../../Services/userService";
import { getPlanDetails } from "../../../Services/pricingPlanService";
import Loader from "../../../Components/UiComponents/Loader";
import AutoCompleteElement from "../../../Components/UiComponents/AutoCompleteElement";
import { api } from "../../../Apis/interceptor";

export default function CreateNewPortfolio(props) {
	const [loading, setLoading] = useState(false);
	const [visible, setVisible] = useState(false);
	const toastRef = useRef();
	const [data, setData] = useState([]);
	const [services, setServices] = useState([]);
	const [businessUnit, setBusinessUnit] = useState([]);
	const [bidLeaderList, setBidLeaderList] = useState([]);
	const [planType, setPlanType] = useState([]);
	const [hasValue, setHasValue] = useState(true);
	const [selectedAssociatedClient, setSelectedAssociatedClient] = useState('');
	const [associatedDataClient, setAssociatedDataClient] = useState([])
	const [cliRes, setCliRes] = useState([])
	const [branchDetails, setBranchDetails] = useState([]);

	const {
		control,
		handleSubmit,
		formState: { errors },
		reset,
		getValues,
		setValue
	} = useForm();

	const clearForm = () => {
		reset();
	};

	const addClient = () => {
		setVisible(true);
		props?.pipelineVisible(true);

	}

	const getBranchDetails = () => {
		setBranchDetails(props?.branchDetails);
	};

	useEffect(() => {
		getBranchDetails();
	}, [props?.branchDetails]);

	useEffect(() => {
		if (props?.customerId) {
			getCustomerDetails();
			getBidLeaderList()
			getPlanDetail()
		}
	}, [props?.customerId]);

	const getCustomerDetails = async () => {
		var customerDataResponse = await getCustomer(props?.customerId);
		var custData = customerDataResponse.data.reference_data;
		setData(custData);
	};

	useEffect(() => {
		if (data && data.length > 0) {
			data.forEach((item) => {
				const activeChoices = item.option_choice.filter(
					(choice) => choice.status === "active"
				);
				switch (item.option_names) {
					case "Services":
						setServices(activeChoices);
						break;
					case "BusinessUnit":
						setBusinessUnit(activeChoices);
						break;
					default:
						break;
				}
			});
		}
	}, [data]);

	const getBidLeaderList = async () => {
		const response = await getUsersList(props?.customerId, props?.branch);
		var listLeaders = []
		for (var data of response.data) {
			let leaders = {
				id: data._id,
				username: data.firstname + ' ' + data.surname,
				firstname: data.firstname,
				surname: data.surname
			}
			listLeaders.push(leaders)
		}
		setBidLeaderList(listLeaders)
	}

	const getPlanDetail = async () => {
		var response = await getPlanDetails(props.pricingPlan);
		setPlanType(response.data.plan_type)
	}

	const onSubmit = async (promptData) => {
		setLoading(true)
		var newCheckData = {};
		const response = await getSeq(props?.customerId);
		const branch = branchDetails.find(branch => branch._id === props?.branchIdFromLS?.branch_id);

		var nxtSeq = 1;
		if (!_.isEmpty(response.data)) {
			nxtSeq = response.data[0].opportunity_seq
				? response.data[0].opportunity_seq + 1
				: 1;
		}

		var curMonth = moment().month();
		var curDate = moment().date();
		curMonth = curMonth + 1; // moment month from 0 - 11
		if (curMonth < 10) curMonth = "0" + curMonth;
		if (curDate < 10) curDate = "0" + curDate;
		var creation_date =
			curDate + "-" + curMonth + "-" + moment().year();

		if (promptData, nxtSeq) {
			newCheckData.opportunity_seq = nxtSeq;
			newCheckData.customer_id = props?.customerId;
			// newCheckData.client_id = promptData.client.client_id;
			// newCheckData.client_name = promptData.client.client_name;
			if (cliRes.length > 0) {
				newCheckData.client_id = cliRes?.find((item) => item.client_name === selectedAssociatedClient)?._id
				newCheckData.client_name = cliRes?.find((item) => item.client_name === selectedAssociatedClient)?.client_name
			}
			newCheckData.creation_date = creation_date;
			newCheckData.updated_by = props?.customer?.username;
			newCheckData.updated_byId = props?.customer?.userid;
			if (!newCheckData.branch_id) {
				//Not Parent Org
				newCheckData.branch_id = promptData?.branch_id?._id || props?.branchIdFromLS?.branch_id;
			}
			newCheckData.branch_name = promptData?.branch_id?.branch_name || branch.branch_name;
			//For logging
			newCheckData.customer_name = props.customer.customer_name;
			newCheckData.createdBy_id = props?.customer?.userid;
			newCheckData.createdBy_name = props?.customer?.username;

			//SaaS Pricing
			newCheckData.plan_type = planType;
			if (planType != "Free") {
				const targetItem = filter(props.oppTypes, { label: "Target" })[0];
				const targetText = targetItem ? targetItem.text : undefined;
				newCheckData.winwork_display = targetText;
			} else {
				const targetItem = filter(props.oppTypes, { label: "Submission" })[0];
				const targetText = targetItem ? targetItem.text : undefined;
				newCheckData.winwork_display = targetText;
			}
			newCheckData.bid_Leader = promptData?.bLeader?.username;
			newCheckData.bid_Leader_id = promptData?.bLeader?.id;
			newCheckData.contract_value = promptData?.contract_value;
			newCheckData.sector = promptData.sector.label ? promptData.sector.label : '';
			newCheckData.estimated_close_gateways = moment(promptData?.estimated_close_gateways).format('DD-MM-YYYY');
			newCheckData.opportunity_name = promptData?.opportunity_name;
			newCheckData.opportunity_type = promptData?.opportunity_type.label;
			newCheckData.opportunity_alias = promptData?.opportunity_alias;
			newCheckData.business_unit = promptData?.business_unit?.label;
			newCheckData.tender_due = moment(promptData?.tender_due).format('DD-MM-YYYY');
			newCheckData.selectedClientStatusIndex = 0;
		}
		try {
			const response = await create(newCheckData);
			if (response?.status === 200) {
				toastRef.current.showToast({
					type: "success",
					message: `${response.data.message}`,
				});
				clearForm();
				setTimeout(() => { closePopup() }, 500)
			} else {
				toastRef.current.showToast({
					type: "error",
					message: "Error",
				});
			}
			setLoading(false)
		} catch (e) {
			console.error(e);
			setLoading(false)
		} finally {
			// closePopup();
			// setLoading(false)
		}
	};


	const closePopup = () => {
		reset();
		setVisible(false);
		props?.onHide();
		setHasValue(true)
	};

	const handleHide = () => {
		setVisible(false);
	}

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className='align-center justify-end pb-0'>
					<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
					<ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit(onSubmit)} />
				</div>
			</div>
		);
	}

	const handleGetClient = async () => {
		var branchId = getValues('branch_id') ? getValues('branch_id') : props.branchIdFromLS ? props.branchIdFromLS.branch_id : ''
		const cliResponse = await api.get("/api/v1/getClients", {
			params: { cust_id: props?.customerId, searchVal: selectedAssociatedClient, branch_id: branchId },
		});
		setCliRes(cliResponse.data?.client)
		const associatedDisplayNames = cliResponse.data?.client?.map(
			(cli) => cli.client_name
		);
		setAssociatedDataClient(associatedDisplayNames);
	};

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<Dialog
				header={_.find(props.projectSectionsNew, { section_name: "New Project" })?.display_name}
				visible={props.visible}
				position={props.position}
				onHide={() => {
					closePopup();
				}}
				footer={renderFooter()}
				className="width-46"
				draggable={false}
			>
				<div className="new-field">
					<form >
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.projectFieldsNew, { field_name: "Project Name" })?.display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="opportunity_name"
									control={control}
									rules={{ required: "Project name must be 2-500 characters in alphanumeric" }}
									render={({ field }) => (
										<InputTextElement id="opportunity_name" {...field} />
									)}
								/>
								{errors.opportunity_name && (
									<small className="text-red-500 color-red">
										{errors.opportunity_name.message}
									</small>
								)}
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.projectFieldsNew, { field_name: "Project Alias" }).display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="opportunity_alias"
									control={control}
									// rules={{ required: "Project alias must be 2-500 characters in alphanumeric" }}
									render={({ field }) => (
										<InputTextElement id="opportunity_alias" {...field} />
									)}
								/>
								{/* {errors.opportunity_alias && (
									<small className="text-red-500 color-red">
										{errors.opportunity_alias.message}
									</small>
								)} */}
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.commanFieldsNew, { field_name: "Services" }).display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="opportunity_type"
									control={control}
									rules={{ required: "Services is required" }}
									style={{ innerHeight: 10 }}
									render={({ field }) => {
										return (
											<DropdownElement
												onChange={(e) => {
													field.onChange(e.value); 
												}}
												id="opportunity_type"
												options={(services != undefined && services.length > 0) ? services : []}
												optionLabel="label"
												placeholder="-- Please select --"
												className="w-full"
												{...field}
												maxSelectedLabels={1}
											/>
										);
									}}
								/>
								{errors.opportunity_type && (
									<small className="text-red-500 color-red">
										{errors.opportunity_type.message}
									</small>
								)}
							</div>
						</div>
						{
							props.havingBranch && props.branchIdFromLS.branch_key == 'main' &&
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left">
										{_.find(props.commanFieldsNew, { field_name: "Branch" }).display_name}:
									</label>
								</div>
								<div className="col pr-0">
									<Controller
										name="branch_id"
										control={control}
										render={({ field }) => {
											const options =
												props?.branchDetails?.map((branch) => ({
													value: branch,
													label: branch.branch_name,
												})) || [];

											return (
												<SingleSelectElement
													id="branch_id"
													{...field}
													name="branch_id"
													options={(options != undefined && options.length > 0 )? options : []}
													optionLabel="label"
													placeholder="-- Please select --"
													maxSelectedLabels={1}
													onChangeValue={(e) => {
														const valueExists = e.value !== null && e.value !== undefined && e.value !== '';
														setHasValue(!valueExists);
														field.onChange(e.value);
													}}
													className="w-full"
												/>
											);
										}}
									/>
									{errors.branch_id && (
										<small className="text-red-500 color-red">
											{errors.branch_id.message}
										</small>
									)}
								</div>
							</div>
						}
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.commanFieldsNew, { field_name: "Business Unit" }).display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="business_unit"
									control={control}
									rules={{ required: "Business unit is required" }}
									style={{ innerHeight: 10 }}
									render={({ field }) => {
										return (
											<DropdownElement
												onChange={(e) => field.onChange(e.value)}
												id="business_unit"
												options={(businessUnit != undefined && businessUnit.length > 0) ? businessUnit : []}
												optionLabel="label"
												placeholder="-- Please select --"
												className="w-full"
												{...field}
												maxSelectedLabels={1}
											/>
										);
									}}
								/>
								{errors.business_unit && (
									<small className="text-red-500 color-red">
										{errors.business_unit.message}
									</small>
								)}
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.commanFieldsNew, { field_name: "Sector" }).display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="sector"
									control={control}
									rules={{ required: "Sector is required" }}
									render={({ field }) => {
										const uniqueSector = props?.pipelineInfo?.filter((sector, index, self) =>
											index === self.findIndex((b) => b.sector === sector.sector)
										) || [];

										const options = uniqueSector.map((sector) => ({
											value: sector,
											label: sector.sector,
										}));
										return (
											<SingleSelectElement
												id="sector"
												{...field}
												name="sector"
												options={(props.sectorType.length > 0 && props.sectorType != undefined) ? props.sectorType : []}
												optionLabel="label"
												placeholder="-- Please select --"
												maxSelectedLabels={1}
												onChangeValue={(e) => field.onChange(e.value)}
												className="w-full"
											/>
										);
									}}
								/>
								{errors.sector && (
									<small className="text-red-500 color-red">
										{errors.sector.message}
									</small>
								)}
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.clientFieldsNew, { field_name: "Client Name" }).display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="client"
									control={control}
									rules={{ required: "Client name is required" }}
									render={({ field }) => {
										const uniqueclientName = props?.pipelineInfo?.filter((clientName, index, self) =>
											index === self.findIndex((b) => b.client_name === clientName.client_name)
										) || [];

										const options = uniqueclientName.map((clientName) => ({
											value: clientName,
											label: clientName.client_name,
										}));
										return (
											<AutoCompleteElement
												id="client"
												value={selectedAssociatedClient}
												onChangeValue={(e) => {
													setValue('client', e.value)
													setSelectedAssociatedClient(e.value)
												}}
												placeholder="Search Client Name"
												suggestions={associatedDataClient}
												autocomplete="off"
												completeMethod={handleGetClient}
												className="w-full"
												isPurposeScore={true}
												{...field}
												disabled={hasValue && props.havingBranch && props.branchIdFromLS.branch_key == 'main'}
											/>
										);
									}}
								/>
								{errors.client && (
									<small className="text-red-500 color-red">
										{errors.client.message}
									</small>
								)}
							</div>
							<div className="col-md-2 pl-0">
								<label className="form-label text-left mb-0">
									<ButtonElement type="button" label="Add" className="add-button-portfolio" onClick={addClient} disabled={hasValue && props.havingBranch && props.branchIdFromLS.branch_key == 'main'} />
								</label>
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.projectFieldsNew, { field_name: "Estimated Contract Value" }).display_name + ' (' + (props.currency ? props.currency : '£') + ')'}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="contract_value"
									control={control}
									rules={{ required: "Budget value is required" }}
									render={({ field }) => (
										<InputTextElement id="contract_value" {...field}
											onKeyPress={(event) => {
												// Prevent comma input
												if (event.key === ',') {
													event.preventDefault();
												}
											}} />
									)}
								/>
								{errors.contract_value && (
									<small className="text-red-500 color-red">
										{errors.contract_value.message}
									</small>
								)}
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.projectFieldsNew, { field_name: "Bid Leader" }).display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="bLeader"
									control={control}
									render={({ field }) => {
										return (
											<SingleSelectElement
												id="bLeader"
												{...field}
												name="bLeader"
												options={(bidLeaderList != undefined && bidLeaderList.length > 0) ? bidLeaderList : []}
												optionLabel='username'
												placeholder="-- Please select --"
												maxSelectedLabels={1}
												onChangeValue={(e) => field.onChange(e)}
												className="w-full"
											/>
										);
									}}
								/>
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{_.find(props.projectFieldsNew, { field_name: "Estimated Tender Due Date" }).display_name}:
								</label>
							</div>
							<div className="col pr-0">
								<Controller
									name="tender_due"
									control={control}
									rules={{ required: "Estimated Tender Due Date is required" }}
									render={({ field }) => (
										<CalendarElement
											id="tender_due"
											{...field}
											placeholder="Choose a date"
										/>
									)}
								/>
								{errors.tender_due && (
									<small className="text-red-500 color-red block mt-1">
										{errors.tender_due.message}
									</small>
								)}
							</div>
							
						</div>
						{
							props.tabPermissions['Gateways'] &&
							<div className="form-group row align-items-center mb-0 mt-0">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left">
										{_.find(props.projectFieldsNew, { field_name: "Estimated Target Gateway Approval Date" }).display_name}:
									</label>
								</div>
								<div className="col pr-0">
									<Controller
										name="estimated_close_gateways"
										control={control}
										render={({ field }) => (
											<CalendarElement
												id="estimated_close_gateways"
												{...field}
												placeholder="Choose a date"
											/>
										)}
									/>
									{errors.estimated_close_gateways && (
										<small className="text-red-500 color-red">
											{errors.estimated_close_gateways.message}
										</small>
									)}
								</div>
							</div>
						}
						{
							visible &&
							<CreateNewStakeHolder
								custmerDetails={props?.custmerDetails}
								branch={props?.branchDetail}
								branchDetails={props?.branchDetails}
								customerId={props?.customerId}
								visible={visible}
								position={props?.position}
								customerTableData={props?.customerTableData}
								onHide={handleHide} relationshipOwner={props?.relationshipOwner}
								clientFieldsNew={props.clientFieldsNew}
								clientSectionsNew={props.clientSectionsNew}
								commonFields={props.commonFields}
								havingBranch={props.havingBranch}
								branchIdFromLS={props.branchIdFromLS}
							/>
						}

					</form>
				</div>
			</Dialog>
		</div>
	)

}